import * as _ from 'underscore';
import moment from 'moment';
import 'moment-recur';

import * as ClipboardState from './../state/reducer/clipboard/clipboard';
import * as Utils from './designerUtils';

export const repeat = (sessions, numWeeks, isSingle, days, isProgram) => {
    sessions = ClipboardState.prepareSessionsForClipboard(_.values(sessions));

    // Calendar types
    if (isSingle && !isProgram)
        return repeatSingleCalendarSession(sessions, numWeeks, days);
    if (!isProgram) return repeatMultipleCalendarSessions(sessions, numWeeks);

    // Program (fixed) types
    if (isSingle) return repeatSingleProgramSession(sessions, numWeeks, days);
    return repeatMultipleProgramSessions(sessions, numWeeks);
};

const repeatMultipleProgramSessions = (sessions, numWeeks) => {
    const firstSessionWeekIndex = sessions[0].obj.weekIndex;
    const firstSessionDayIndex = sessions[0].obj.index;
    const lastSessionWeekIndex = _.last(sessions).obj.weekIndex;
    const weekCountInRepeat = lastSessionWeekIndex - firstSessionWeekIndex + 1;

    for (let i = 1; i <= numWeeks; i++) {
        const weekIndexToPaste = i * weekCountInRepeat + firstSessionWeekIndex;
        const pasteDayKey = `${weekIndexToPaste}_${firstSessionDayIndex}`;
        ClipboardState.pasteSessions(sessions, pasteDayKey);
    }
};

const repeatSingleProgramSession = (sessions, numWeeks, days) => {
    const firstSessionWeekIndex = sessions[0].obj.weekIndex;
    const firstSessionDayIndex = sessions[0].obj.index;

    for (let i = 0; i <= numWeeks; i++) {
        for (let j = 0; j < days.length; j++) {
            if (i === 0 && days[j] <= firstSessionDayIndex) continue;
            // do not paste on or before today

            const pasteDayKey = `${i + firstSessionWeekIndex}_${days[j]}`;
            ClipboardState.pasteSessions(sessions, pasteDayKey);
        }
    }
};

const repeatSingleCalendarSession = (sessions, numWeeks, days) => {
    const firstSessionDay = moment(sessions[0].obj.date, 'YYYY-MM-DD').day();

    for (let i = 0; i <= numWeeks; i++) {
        for (let j = 0; j < days.length; j++) {
            if (i === 0 && days[j] <= firstSessionDay) continue;
            // do not paste on or before today

            const pasteDate = moment(sessions[0].obj.date, 'YYYY-MM-DD')
                .startOf('week')
                .add(i, 'weeks')
                .add(days[j], 'days');

            const pasteDayKey = Utils.getDayKey(pasteDate);
            ClipboardState.pasteSessions(sessions, pasteDayKey);
        }
    }
};

const repeatMultipleCalendarSessions = (sessions, numWeeks) => {
    const firstSessionDate = moment(sessions[0].obj.date, 'YYYY-MM-DD');
    const lastSessionDate = moment(_.last(sessions).obj.date, 'YYYY-MM-DD');
    const weekCountInRepeat =
        lastSessionDate.week() - firstSessionDate.week() + 1;

    for (let i = 1; i <= numWeeks; i++) {
        const pasteDate = moment(sessions[0].obj.date, 'YYYY-MM-DD').add(
            i * weekCountInRepeat,
            'weeks'
        );
        const pasteDayKey = Utils.getDayKey(pasteDate);

        ClipboardState.pasteSessions(sessions, pasteDayKey);
    }
};
